export const INCENTIVE_TYPE = {
  FIXED: 'fixed',
  PERCENT: 'percentage'
};

export const INCENTIVE_OPTIONS = [
  { label: 'Fixed Incentive', value: INCENTIVE_TYPE.FIXED },
  { label: 'Percentage Incentive', value: INCENTIVE_TYPE.PERCENT }
];
